import React, { useMemo } from "react";
import { Dialog } from "primereact/dialog";
import { Chart } from "primereact/chart";
import type { WeeklyStationMetric } from "../../../types/kpiDashboard";
import { COCHARGE_DARK_GREEN, COCHRAGE_DARK_GREEN_RGBA } from "../../../styles/theme_constants";

interface Props {
  visible: boolean;
  onHide: () => void;
  trend: WeeklyStationMetric[];
}

const OnlineRateDetailDialog: React.FC<Props> = ({ visible, onHide, trend }) => {
  const chartData = useMemo(() => ({
    labels: trend.map((d) => d.period),
    datasets: [
      {
        label: "Online %",
        data: trend.map((d) => d.onlinePct),
        borderColor: COCHARGE_DARK_GREEN,
        backgroundColor: COCHRAGE_DARK_GREEN_RGBA(0.1),
        tension: 0.4,
        fill: true,
        pointRadius: 4,
        pointBackgroundColor: COCHARGE_DARK_GREEN,
      },
    ],
  }), [trend]);

  const chartOptions = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 300 },
    interaction: { mode: "index" as const, intersect: false },
    plugins: {
      legend: {
        position: "top" as const,
        labels: { color: "#495057", font: { size: 13 }, padding: 16 },
      },
      tooltip: {
        callbacks: {
          label: (ctx: any) => ` Online Rate: ${ctx.parsed.y.toFixed(1)}%`,
        },
      },
    },
    scales: {
      x: {
        ticks: { color: "#6c757d", font: { size: 11 } },
        grid: { color: "#f3f4f6" },
      },
      y: {
        min: 60,
        max: 100,
        ticks: {
          color: "#6c757d",
          callback: (v: number) => `${v}%`,
        },
        grid: { color: "#f3f4f6" },
        title: { display: true, text: "Online Rate (%)", color: "#6c757d" },
      },
    },
  }), []);

  return (
    <Dialog
      header="Online Rate (%) — Trend"
      visible={visible}
      onHide={onHide}
      style={{ width: "90vw", maxWidth: "1100px" }}
      modal
      dismissableMask
    >
      <Chart
        type="line"
        data={chartData}
        options={chartOptions}
        style={{ height: "460px" }}
      />
    </Dialog>
  );
};

export default OnlineRateDetailDialog;
